export enum OnixRoleEnum {
    ADMIN = "Admin",
    TENANT = "Tenant",
    USER = "User",
    ENVIRONMENTTESTER = "EnvironmentTester",
    TESTER = "Tester",
    DEVELOPER = "Developer",
    GRUNF_SUPPORT = "GrunfSupport",
    PORTAL = "Portal",
}
